import {DOCUMENT, ViewportScroller} from '@angular/common';
import {Component, ElementRef, Inject, Input, OnInit, Renderer2, TemplateRef} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {NavigationEnd, Router} from '@angular/router';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {filter} from 'rxjs';
import {ScrollService} from 'src/app/components/helper/service/scroll/scroll.service';
declare global {
  interface Window {
    jQuery: any;
    $: any;
  }
}
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isClienteArea: boolean = true;
  showClass = 'hide-panel';
  @Input() estilo: {[key: string]: string} | null = null;
  @BlockUI() public blockUI!: NgBlockUI;
  urlIframe!: SafeResourceUrl;
  modalRef?: BsModalRef;
  constructor(
    private scroller: ViewportScroller,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private sanitizer: DomSanitizer,
    private modalService: BsModalService,
    private _scrollService: ScrollService,
  ) {}

  ngOnInit(): void {
    if (!this.isClienteArea) this.router.navigateByUrl('/home');
    this.verificarEstiloPortal();
    // Aguarda o carregamento do jQuery e inicializa o menu
    setTimeout(() => {
      this.inicializarMainMenu();
    }, 200);

    // Reincializa após navegação
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      setTimeout(() => {
        this.inicializarMainMenu();
      }, 300);
    });
  }

  verificarEstiloPortal(): string {
    if (this.router.url.includes('portal') && !this.router.url.includes('cotacao')) {
      return 'estilo-portal';
    }
    return '';
  }

  goToLogin() {
    // window.location.href = "http://portal-geia-stage.azurewebsites.net/conta/login";
  }

  pMe2A29Vidas(template: TemplateRef<any>) {
    this.blockUI.start();
    this.navigateToSection('geia-empresa');
    const urlFrame = 'https://portal.geia.com.br/home/SimuladorPlena';
    this.urlIframe = this.sanitizer.bypassSecurityTrustResourceUrl(urlFrame);

    this.modalRef = this.modalService.show(template, {class: 'modal-xl'});

    setTimeout(() => {
      this.blockUI.stop();
    }, 3000);
  }

  decline(): void {
    this.modalRef?.hide();
  }

  navigateToSection(sectionId: string, isMobile?: string): void {
    const marginTop = 140;

    if (isMobile) {
      // Fecha o menu mobile
      if (window.jQuery) {
        window.jQuery('.mobile-slide-panel').removeClass('show-panel');
      }
    }

    if (sectionId === 'home') {
      const sectionName = document.getElementById(sectionId);
      if (sectionName) {
        this.router.navigateByUrl('/' + 'home').then(() => {
          sectionName.scrollIntoView();
          // Reinicializa o menu após navegação
          setTimeout(() => this.inicializarMainMenu(), 200);
        });
      }
    } else if (sectionId === 'saude' || sectionId === 'seguro' || sectionId === 'odonto') {
      return this._scrollService.navigateToSection(sectionId, 'portal', isMobile, marginTop);
    } else {
      this._scrollService.navigateToSection(sectionId, '', isMobile, 0);
    }
  }

  fecharMenuMobile() {
    if (window.jQuery) {
      window.jQuery('.mobile-slide-panel').removeClass('show-panel');
    }
  }

  closeMenuMobile() {
    this.fecharMenuMobile();
  }

  inicializarMainMenu() {
    // @ts-ignore - Ignorar erro do jQuery se não tiver tipos
    const $ = window.jQuery;

    if (!$) return;

    const navbarToggler = $('.navbar-toggler');
    const mobilePanel = $('.mobile-slide-panel');
    const panelOverly = $('.panel-overlay');
    const navClose = $('.panel-close');
    const mobilePanelMenu = $('.mobile-menu');

    // Remove eventos anteriores
    navbarToggler.off('click');
    panelOverly.off('click');
    navClose.off('click');

    // Panel Click Event
    navbarToggler.on('click', function (e) {
      e.preventDefault();
      mobilePanel.toggleClass('show-panel');
    });

    navClose.on('click', function (e) {
      e.preventDefault();
      mobilePanel.removeClass('show-panel');
    });

    panelOverly.on('click', function (e) {
      e.preventDefault();
      mobilePanel.removeClass('show-panel');
    });

    // Remove todos os spans dd-trigger existentes para recriar
    mobilePanelMenu.find('.dd-trigger').remove();

    // Adiciona toggle button to li items that have children
    mobilePanelMenu.find('li a').each(function () {
      if ($(this).next().length > 0) {
        $(this).append('<span class="dd-trigger"><i class="fa fa-angle-down fa-2x"></i></span>');
      }
    });

    // Remove eventos anteriores dos triggers
    mobilePanelMenu.find('.dd-trigger').off('click');

    // Expands the dropdown menu on each click
    mobilePanelMenu.find('.dd-trigger').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).parent().parent('li').children('ul.sub-menu').stop(true, true).slideToggle(350);
      $(this).toggleClass('sub-menu-opened');
    });
  }
}
